// extracted by mini-css-extract-plugin
export default {"videoContainer":"inactivityTimer_videoContainer__JiH1o","video":"inactivityTimer_video__rFp3s","closeTouchpoint":"inactivityTimer_closeTouchpoint__gVVry"};